// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"S--z"};